/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransactionDto
 */
export interface TransactionDto {
    /**
     * Transaction ID
     * @type {string}
     * @memberof TransactionDto
     */
    id: string;
    /**
     * Transaction datetime
     * @type {Date}
     * @memberof TransactionDto
     */
    datetime: Date;
    /**
     * Transaction item description
     * @type {string}
     * @memberof TransactionDto
     */
    item: string;
    /**
     * Total amount in cents
     * @type {number}
     * @memberof TransactionDto
     */
    totalAmount: number;
    /**
     * Transaction status
     * @type {string}
     * @memberof TransactionDto
     */
    status: string;
    /**
     * Invoice ID for viewing invoice
     * @type {string}
     * @memberof TransactionDto
     */
    invoiceId: string;
    /**
     * Currency code
     * @type {string}
     * @memberof TransactionDto
     */
    currency: string;
    /**
     * PDF URL
     * @type {string}
     * @memberof TransactionDto
     */
    pdfUrl: string;
    /**
     * Hosted invoice URL
     * @type {string}
     * @memberof TransactionDto
     */
    hostedInvoiceUrl: string;
}

/**
 * Check if a given object implements the TransactionDto interface.
 */
export function instanceOfTransactionDto(value: object): value is TransactionDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('datetime' in value) || value['datetime'] === undefined) return false;
    if (!('item' in value) || value['item'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('invoiceId' in value) || value['invoiceId'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('pdfUrl' in value) || value['pdfUrl'] === undefined) return false;
    if (!('hostedInvoiceUrl' in value) || value['hostedInvoiceUrl'] === undefined) return false;
    return true;
}

export function TransactionDtoFromJSON(json: any): TransactionDto {
    return TransactionDtoFromJSONTyped(json, false);
}

export function TransactionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'datetime': (new Date(json['datetime'])),
        'item': json['item'],
        'totalAmount': json['totalAmount'],
        'status': json['status'],
        'invoiceId': json['invoiceId'],
        'currency': json['currency'],
        'pdfUrl': json['pdfUrl'],
        'hostedInvoiceUrl': json['hostedInvoiceUrl'],
    };
}

export function TransactionDtoToJSON(json: any): TransactionDto {
    return TransactionDtoToJSONTyped(json, false);
}

export function TransactionDtoToJSONTyped(value?: TransactionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'datetime': ((value['datetime']).toISOString()),
        'item': value['item'],
        'totalAmount': value['totalAmount'],
        'status': value['status'],
        'invoiceId': value['invoiceId'],
        'currency': value['currency'],
        'pdfUrl': value['pdfUrl'],
        'hostedInvoiceUrl': value['hostedInvoiceUrl'],
    };
}

